import { InlineCalendar } from "PFComponents/calendar/inline_calendar";

import { ComponentProps } from "../component_prop_types";

type InlineCalendarWrapperProps = Pick<
  ComponentProps,
  | "property"
  | "label"
  | "qaId"
  | "title"
  | "formattedTitle"
  | "style"
  | "error"
  | "required"
  | "disabled"
  | "variant"
  | "className"
  | "portalRef"
  | "tabIndex"
  | "inputRef"
> & {
  value?: string | null;
  onChange: (value: string | null) => void;
};

export const InlineCalendarWrapper = ({
  property: { type },
  value,
  label,
  onChange,
  qaId,
  title,
  formattedTitle,
  style,
  error,
  required,
  disabled,
  variant,
  className,
  portalRef,
  tabIndex,
  inputRef
}: InlineCalendarWrapperProps) => (
  <InlineCalendar
    inputClassName={className}
    selectedDate={value}
    label={label}
    title={formattedTitle || title}
    qaId={qaId}
    error={error}
    required={required}
    showTime={type === "date-time"}
    shouldCloseOnSelection={type !== "date-time"}
    handleChange={onChange}
    disabled={disabled}
    variant={variant}
    portalRef={portalRef}
    letClear
    tabIndex={tabIndex}
    style={style}
    inputRef={inputRef}
  />
);
